/**
 * Route for `cap-hit-auto-pause`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CapHitAutoPausePage } from "../features/cap-hit-auto-pause/CapHitAutoPausePage";

export const capHitAutoPauseRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/cap-hit-auto-pause",
	component: CapHitAutoPausePage,
});

export default capHitAutoPauseRoute;
